import { Activity, Message } from 'botframework-directlinejs';
import { IBotOutgoingMessageValue, IEventCall } from '../../botTypes';

// When a streaming activity replaces an earlier one, the newer chunk may not
// contain EventCalls even though earlier chunks did.  This helper merges
// EventCalls from the previous activity into the replacement so the
// ProgressIndicator always has the full set of events to display.
export const getActivityWithMergedEventCalls = (
  existingActivity: Activity,
  newActivity: Activity
): Activity => {
  const existingValue = ((existingActivity as Message).value || {}) as IBotOutgoingMessageValue;
  const existingEventCalls: IEventCall[] = existingValue.EventCalls || [];

  if (existingEventCalls.length === 0) {
    return newActivity;
  }

  const newMessage = newActivity as Message;
  const newValue = (newMessage.value || {}) as IBotOutgoingMessageValue;
  const newEventCalls: IEventCall[] = newValue.EventCalls || [];

  // Merge: deduplicate by EventName+EventTimeStamp, keep all unique events
  const seen = new Set(newEventCalls.map(e => `${e.EventName}|${e.EventTimeStamp}`));
  const merged = [
    ...existingEventCalls.filter(e => !seen.has(`${e.EventName}|${e.EventTimeStamp}`)),
    ...newEventCalls,
  ];

  return {
    ...newMessage,
    value: {
      ...newValue,
      EventCalls: merged,
    },
  };
};
